import { getText } from '../../utils/functions';
import SimpleButton from '../basicComponents/SimpleButton';


function ConfirmationPopUp({
	translate,
	data,
	onConfirm,
	onCancel,
	colors,

	/* OPTIONAL PROPS */
	icon,
	classNameDIV = 'py-12 px-16 flex flex-col space-y-7 items-center rounded-sm',
	styleDIV,
	classNameIMG = 'w-20 h-20',
	styleIMG,
	classNameTEXT = 'text-xs md:text-base',
	styleTEXT,
	classNameBTNS = 'flex flex-row space-x-8 w-max',
	styleBTNS,
	classNameBTN = 'px-5 cursor-pointer py-3 focus:outline-none text-sm md:text-base bold rounded-md md:w-max w-full',
}) {
	/* Default values for the styles */ // className='p-
	const defaultStyleDIV = {
		backgroundColor: `${colors?.background}`,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleTEXT = {
		color: `${colors?.primary}`
	};
	const defaultStyleIMG = {
		color: `${colors?.primary}`
	};
	const defaultStyleBTNS = {
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDiv = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleTEXT = { ...defaultStyleTEXT, ...styleTEXT };
	const overrideStyleIMG = { ...defaultStyleIMG, ...styleIMG };
	const overrideStyleBTNS = { ...defaultStyleBTNS, ...styleBTNS };

	return <div
		id='InformationPopUp'
		className={classNameDIV}
		style={overrideStyleDiv}
	>
		{/* ICON */}
		{icon
		&& <img
			src={icon}
			alt='errorIcon'
			className={classNameIMG}
			style={overrideStyleIMG}
		/>}
		{/* TEXT */}
		<div
			className={classNameTEXT}
			style={overrideStyleTEXT}
			dangerouslySetInnerHTML={{ __html: getText(data?.information, translate) }}
		/>

		{/* SEND BUTTON */}
		<div className={classNameBTNS} style={overrideStyleBTNS}>
			{/* CONFIRM */}
			<SimpleButton
				colors={colors}
				classNameBTN={classNameBTN}
				fillMode={false}
				tag={getText(data?.confirmButton, translate)}
				onClick={() => onConfirm()}
			/>
			{/* CANCEL */}
			<SimpleButton
				colors={colors}
				classNameBTN={classNameBTN}
				tag={getText(data?.cancelButton, translate)}
				onClick={() => onCancel()}
			/>
		</div>
	</div>;
}

export default ConfirmationPopUp;
